import * as React from "react";

import { GlobalStyles } from "../../styles/base-styles";
import styled from "@emotion/styled";

const StyledRoot = styled.div`
	display: flex;
	flex-direction: column;
	min-height: 100vh;
`;

export const Root = ({children}) => (
  <>
    <GlobalStyles />
	<StyledRoot>{children}</StyledRoot>
  </>
);
